import {
  Identifiable,
  Planzone,
  ProjectDetailsConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function updateProjectDetailsConfiguration(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    configuration: ProjectDetailsConfiguration,
    nextConfiguration: ProjectDetailsConfiguration,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${uuid}`,
      method: HttpMethods.PATCH,
      data: {
        data: {
          projectDetailsConfiguration: JSON.stringify(nextConfiguration),
        },
      },
    });
}

export { updateProjectDetailsConfiguration };
